import type { ReactNode } from 'react'

export type BadgeVariant =
  | 'primary'
  | 'secondary'
  | 'info-dark'
  | 'info'
  | 'warning'
  | 'danger'
  | 'success'
  | 'orange'
  | 'purple'
  | 'neutral'

export const Badge = ({ children, variant = 'info' }: { children: ReactNode; variant?: BadgeVariant }) => {
  const findColor = () => {
    switch (variant) {
      case 'primary':
        return 'ap:bg-primary ap:text-content-inverse'
      case 'secondary':
        return 'ap:bg-secondary-light ap:text-primary-dark'
      case 'info-dark':
        return 'ap:bg-surface-info-dark ap:text-content-inverse'
      case 'info':
        return 'ap:bg-surface-background ap:border ap:border-stroke-primary ap:text-content-primary'
      case 'warning':
        return 'ap:bg-surface-warning-light ap:text-content-warning'
      case 'danger':
        return 'ap:bg-surface-danger-light ap:text-content-danger'
      case 'success':
        return 'ap:bg-surface-success-light ap:text-content-success'
      case 'orange':
        return 'ap:bg-surface-orange ap:text-content-orange'
      case 'purple':
        return 'ap:bg-surface-purple ap:text-content-purple'
      case 'neutral':
        return 'ap:bg-surface-background ap:text-content-secondary'
      default:
        return 'ap:bg-primary ap:text-content-inverse'
    }
  }
  const color = findColor()

  return (
    <div
      className={`${color} ap:flex ap:items-center ap:justify-center ap:text-xs ap:py-xs ap:px-lg ap:rounded-full ap:w-fit ap:font-semibold ap:uppercase`}
    >
      {children}
    </div>
  )
}
